import map from "lodash/fp/map";

class Controller {
  constructor(
    $mdDialog,
    $injector,
    route,
    scheduleId,
    faild,
    originalSchedule
  ) {
    "ngInject";

    this.page = 1;
    this.rides = [];
    this.selected = [];
    this.faild = faild;
    this.route = route;
    this.scheduleId = scheduleId;
    this.originalSchedule = originalSchedule;
    this.$mdDialog = $mdDialog;
    this.$injector = $injector;
    this.RidesTransforms = $injector.get("RidesTransforms");

    this.get();
  }

  get(options) {
    const validCheck = (item) => {
      const isNotValid = this.faild.find((f) => f._id === item._id);
      if (isNotValid) {
        item.label = isNotValid.message;
      }

      return item;
    };
    const route = this.route;
    const defaultOptions = {
      route,
      status: ["scheduled"],
      schedule_id: this.scheduleId,
    };
    const params = Object.assign({}, defaultOptions, options);

    this.$injector
      .get("Ride")
      .getAll(params)
      .$promise.then((response) => {
        this.rides = [
          ...this.rides,
          ...map(validCheck)(this.RidesTransforms.justify(response.hits)),
        ];
        this.selected = [
          ...this.selected,
          ...map(validCheck)(this.RidesTransforms.justify(response.hits)),
        ];
        this.showLoadMore = response.total > this.rides.length;
      });
  }

  toggle(item) {
    const idx = this.selected.findIndex((s) => s._id === item._id);
    if (idx > -1) {
      this.selected.splice(idx, 1);
    } else {
      this.selected.push(item);
    }
  }

  exists(item) {
    if (this.selected && this.selected.length > 0) {
      return this.selected.findIndex((s) => s._id === item._id) > -1;
    }
    return false;
  }

  loadMore() {
    this.page += 1;

    this.get({ page: this.page });
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    if (this.selected.length > 0) {
      this.$mdDialog.hide(this.selected);
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/route/dialog/dialog.controller.js